module.exports = __webpack_public_path__ + "img/09_daughter.dba2f79d.png";